var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 360,
    viewBox: "0 0 326 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      height: "1em",
      transform: "scale(1.3) translateY(-20%)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 346.502H313.152",
    stroke: "#0F0F0F",
    strokeWidth: 25.0127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.355 119.385H29.6751C20.5038 119.385 13 126.889 13 136.06V279.8C13 288.972 20.5038 296.475 29.6751 296.475H56.355C65.5263 296.475 73.0301 288.972 73.0301 279.8V136.06C73.0301 126.889 65.5263 119.385 56.355 119.385Z",
    stroke: "#0F0F0F",
    strokeWidth: 25.0127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.401 66.1926H149.722C140.551 66.1926 133.047 73.6964 133.047 82.8677V279.8C133.047 288.972 140.551 296.475 149.722 296.475H176.401C185.572 296.475 193.076 288.972 193.076 279.8V82.8677C193.076 73.6964 185.572 66.1926 176.401 66.1926Z",
    stroke: "#0F0F0F",
    strokeWidth: 25.0127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296.484 13H269.804C260.633 13 253.129 20.5038 253.129 29.6751V279.802C253.129 288.973 260.633 296.477 269.804 296.477H296.484C305.656 296.477 313.159 288.973 313.159 279.802V29.6751C313.159 20.5038 305.656 13 296.484 13Z",
    stroke: "#0F0F0F",
    strokeWidth: 25.0127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ba79484ef99b2ed04549989c96f7f138.svg";
export { ForwardRef as ReactComponent };